@if (!isStreamView) {
    <div class="content-width">
        <!-- Show the list of the matches inside the tie -->
        <!-- Matches are grouped by the collection definition -->
        @if (groupedMatches.length) {
            <ion-list class="ion-no-padding">

                @for (matchGroup of groupedMatches; let i = $index; track i) {
                    <ion-item-group>
                        <!-- For each collection definition show the header that contains that name -->
                        <!-- Owner can remove collection from the header -->
                        <app-collection-header [hidden]="isLiveMatchesOnly" [collectionDefinition]="matchGroup.collectionDefinition" [canRemoveCollection]="(!this.tie?.organisations?.length && isOwner) || (this.tie?.organisations?.length > 0 && i > 1)" [tie]="tie" (updateMatchGroup)="getGroupedMatches()"></app-collection-header>

                        <!-- Show matches inside teh collection -->
                        @for (matchInfo of matchGroup.matchInfos; let j = $index; track j) {
                            @if (matchInfo.match) {
                                <div [hidden]="isLiveMatchesOnly && matchInfo.match.matchStatus !== 'IN_PROGRESS'">

                                    <!-- Matches are initially built without sides -->
                                    <!-- If sides are available show the match -->
                                    @if (isParticipant(matchInfo)) {
                                        <app-tie-match-scoreboard [match]="matchInfo.match" [isListView]="true"></app-tie-match-scoreboard>
                                    } @else {
                                        <ion-item>
                                            <ion-label class="ion-text-wrap">
                                                <p>
                                                    #{{ matchInfo.match.collectionPosition }} {{ tie.sides[0].team?.abbreviation || tie.sides[0].team?.name}} - #{{ matchInfo.match.collectionPosition }} {{ tie.sides[1].team?.abbreviation || tie.sides[1].team?.name }}
                                                </p>
                                            </ion-label>
                                            <ion-button *ngIf="isOwner || isTracker" (click)="editMatch(matchInfo.match, matchGroup.collectionDefinition, matchInfo.collectionValueProfile)" expand="block" fill="clear" slot="end">
                                                <ion-icon slot="icon-only" name="add"></ion-icon>
                                            </ion-button>
                                        </ion-item>
                                    }
                                </div>
                            }
                        }
                    </ion-item-group>
                }
            </ion-list>
        }

        @if (tie && !tie.tieFormat.collectionDefinitions.length) {
            <app-empty-page text="{{'There are no matches' | translate}}" iconName="tennisball"></app-empty-page>
        }
    </div>

    @if (tie.matchStatus !== 'TBP' && matches?.length) {
        <ion-button style="margin: 20px;" (click)="exportCsv()" expand="block" fill="clear" shape="round">
            {{'Download' | translate}}
        </ion-button>
    }

} @else {
    @if (groupedMatches.length) {
        @for (matchGroup of groupedMatches; let i = $index; track i) {
            <ion-row>
                @for (matchInfo of matchGroup.matchInfos; let j = $index; track j) {
                    <ion-col [size]="theme === 'split-videoboard' ? 12 : 4">
                        <app-tie-match-scoreboard [match]="matchInfo.match" [isListView]="true"></app-tie-match-scoreboard>
                    </ion-col>
                }
            </ion-row>
        }
    }

    @if (tie && !tie.tieFormat.collectionDefinitions.length) {
        <app-empty-page text="{{'There are no matches' | translate}}" iconName="tennisball"></app-empty-page>
    }
}

<div class="ion-margin" hidden="!isLoading">
    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>

